<div class="content">
  <div class="images">
    <img src="/images/about/team.webp" width="362" height="271.5" alt="Team Image" appSlideRight [slideRightDelay]="200"
      (click)="viewImage('/images/about/team.webp')" />
  </div>

  <article>
    <h2 appSlideup [slideUpDelay]="100">Meet the Team Behind {{appname}}</h2>
    <p appSlideup [slideUpDelay]="200">
      {{appname}} is built by a young, hands-on team with a shared love for fashion, everyday beauty, and modern
      lifestyle. From product selection and design direction to operations, tech, and fulfillment, every part of our
      team works closely together to bring thoughtful, wearable pieces to life.
    </p>
    <p appSlideup [slideUpDelay]="300">
      Led by serial entrepreneurs, we are still growing, learning, and creating every day. Our goal is simple: to build
      a women’s fashion brand that feels young, confident, real, and close to everyday life.
    </p>
    <a routerLink="/contact-us">Contact Us</a>
    <!-- <p
      appSlideup
      [slideUpDelay]="400"
      style="
        font-size: 1rem;
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
      "
    >
      <mat-icon fontIcon="location_on" inline></mat-icon
      ><span>1401 21ST ST #13391 SACRAMENTO, CA 95811</span>
    </p>
    <a app-instgram-logo [size]="16"></a> -->
  </article>
</div>